import { useScriptClarity, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const clarity = useScriptClarity({"id":"ic07rl1j4v"})
    return { provide: { $scripts: { clarity } } }
  }
})